import FestivalCards from "@features/landing/components/common/Cards/layout";
import FestivalFooter from "../common/footer";

import FestivalCategoriesSlider from "../common/CategoriesSlider";
import { FESTIVAL_TYPE, FestivalProps } from "@features/landing/types";

type Props = Omit<FestivalProps, "queryParams">;

const PercentageFestivalDefault: React.FC<Props> = ({ festivalData }) => {
  if (!festivalData) return null;
  const {
    type = FESTIVAL_TYPE.PERCENT,
    footer_description,
    slug = "",
  } = festivalData.data.festival;
  const { categories } = festivalData.data;

  return (
    <>
      {Boolean(categories?.length) && (
        <FestivalCategoriesSlider data={categories} />
      )}
      <FestivalCards slug={slug} />
      {footer_description && (
        <FestivalFooter theme={type} description={footer_description} />
      )}
    </>
  );
};

export default PercentageFestivalDefault;
